<template>
  <div class="file-input">
    <input
      ref="fileInput"
      type="file"
      accept="application/pdf"
      @change="onSelectFile()"
    />
  </div>
</template>

<script>
export default {
  name: 'FileInput',
  data() {
    return {
      fileObject: null,
      fileData: null, // base64 string
    };
  },
  methods: {
    chooseFile() {
      this.$refs.fileInput.click();
    },
    onSelectFile() {
      const input = this.$refs.fileInput;
      const { files } = input;
      if (files && files[0]) {
        [this.fileObject] = files;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.fileData = e.target.result;
        };
        reader.readAsDataURL(files[0]);
      }
    },
    discardFile() {
      this.fileObject = null;
      this.fileData = null;
    },
  },
  watch: {
    fileData(newValue) {
      this.$emit('input', newValue);
    },
  },
};
</script>
